export const iconFontAwesomeAlertBellSlash = (
	<i className="fa-solid fa-bell-slash"></i>
);
